import { T27 } from "./CustomerGroupSales/T27";
import { T27_02 } from "./ProductSales/T27_02";
import { T26 } from "./ProductSalesPerf/T26";

export const AgentCustomerGroupProduct = {
  "sections": [
    T27,
    T27_02,
    T26
  ]
};
